import React from 'react'
import { Platform, TextStyle, View, ViewStyle } from "react-native";
import { BaseToast, ErrorToast, ToastConfig, ToastProps } from "react-native-toast-message";
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { Icon } from '../components/atoms/Icon'
import { useTheme } from '@react-navigation/native';

const baseToastStyle: ViewStyle = {
  borderLeftWidth: 0,
  borderRadius: 16,
  paddingVertical: 10,
  // The library fixes the box at 60: a title with a message of three or four
  // lines was drawn over its edges. Short toasts keep the 60, long ones grow.
  height: 'auto',
  minHeight: 60,
  marginRight: 10,
  shadowColor: '#000',
  shadowOpacity: 0.12,
  shadowRadius: 12,
  shadowOffset: { width: 0, height: 6 },
  elevation: 6,
  // Helps on web to feel like "top-right" toasts
  alignSelf: 'flex-end',
  maxWidth: 420,
};

const text1Style: TextStyle = {
  fontSize: 14,
  fontWeight: '700',
};

const text2Style: TextStyle = {
  fontSize: 13,
  opacity: 0.85,
};

const iconWrapper: ViewStyle = {
  justifyContent: 'center',
  alignItems: 'center',
  paddingLeft: 12,
}

export const toastConfig: ToastConfig = {
    success: (props: ToastProps) => {
      const theme = useTheme()
      const insets = useSafeAreaInsets()
      const isWeb = Platform.OS === 'web'
      return (
        <BaseToast
          {...props}
          style={[baseToastStyle, !isWeb && { marginTop: insets.top }]}
          text1Style={text1Style}
          text2Style={text2Style}
          text1NumberOfLines={2}
          text2NumberOfLines={4}
          renderLeadingIcon={() => (
            <View style={iconWrapper}>
              <Icon name="check" size={20} color={theme.colors.green} />
            </View>
          )}
        />
      )},
    error: (props: ToastProps) => {
      const theme = useTheme()
      const insets = useSafeAreaInsets()
      const isWeb = Platform.OS === 'web'
      return (
        <ErrorToast
          {...props}
          style={[baseToastStyle, !isWeb && { marginTop: insets.top }]}
          text1Style={text1Style}
          text2Style={text2Style}
          text1NumberOfLines={2}
          text2NumberOfLines={4}
          renderLeadingIcon={() => (
            <View style={iconWrapper}>
              <Icon name="alertTriangle" size={20} color={theme.colors.error} />
            </View>
          )}
        />
      )},
    info: (props: ToastProps) => {
      const theme = useTheme()
      const insets = useSafeAreaInsets()
      const isWeb = Platform.OS === 'web'
      return (
        <BaseToast
          {...props}
          style={[baseToastStyle, !isWeb && { marginTop: insets.top }]}
          text1Style={text1Style}
          text2Style={text2Style}
          text1NumberOfLines={2}
          text2NumberOfLines={4}
          renderLeadingIcon={() => (
            <View style={iconWrapper}>
              <Icon name="alert" size={20} color={theme.colors.primary} />
            </View>
          )}
        />
      )},
};
